import Vue from "vue";

Vue.component("caselaw-export-button", {
    props: [
        'ids',
        'isExportVisible',
        'filter'
    ],
    data() {
        return {
            recipients: [],
            errors: {},
            isExporting: false,
            showEmailInput: false,
            isSending: false,
            inputLabel: window.labels.recipient,
            inputPlaceholder: window.placeholders.recipient,
            exportingLabel: window.labels.exporting,
            exportLabel: window.labels.export,
            downloadLabel: window.labels.download,
            sendViaEmailLabel: window.labels.sendViaEmail,
            sendLabel: window.labels.send,
            sendingLabel: window.labels.sending,
            cancelLabel: window.labels.cancel,
            exportAllResultLabel: window.labels.exportAllResults

        };
    },
    methods: {
        exportDetails: function () {
            this.isExporting = true;

            var filterModel = {
                dateFrom: this.filter.dateFrom ? moment(this.filter.dateFrom) : undefined
            };
            for (const [key, value] of Object.entries(this.filter)) {
                filterModel[key] = value;
            }

            var filter = this.getWithExpiry('searchFilters') || {};

            filter.ids = this.ids;
            console.log(filter)
            this.$services.caseLaws.exportAllResults(filter)
                .then(({ data: blob }) => {
                    if (blob) {
                        const link = document.createElement('a');
                        const url = URL.createObjectURL(blob);
                        link.href = url;
                        link.download = `TCLD.zip`;
                        link.click();

                    } else {
                        this.$buefy.dialog.alert({
                            title: 'Export Download',
                            message: "An Error has occured while trying to export search results",
                            confirmText: window.labels.closeText
                        });
                    }
                
                    this.isExporting = false;
                    this.showEmailInput = false;

                });
        },
        sendEmail: async function () {
            this.isSending = true;
            var viewModel = {
                recipients: this.recipients,
                ids: this.ids,
                errors: {
                }
            }; 

            var filter = this.getWithExpiry('searchFilters') || {};
         
            filter.recipients = this.recipients;
            filter.ids = this.ids;
            await this.$services.caseLaws.sendDetailsByEmail(filter)
                .then((response) => {
                    if (response.status !== 200) {
                        this.errors = response.data.errors;

                    } else {
                        this.errors = {};
                        this.showEmailInput = false;
                    }
                    this.isSending = false;
                });
        },
        showEmailModal: function () {
            this.showEmailInput = true;
            this.emailAddresses = [];
        }
    },
    computed: {
        hasSelected: function () {
            return this.ids.length > 0;
        }
    },
    template: `
    <section class="is-inline-flex">
	    <b-dropdown :triggers="['hover']" aria-role="list" position="is-bottom-left">
            <template #trigger>
                <button type="button" class="button is-success" v-if="isExportVisible" :disabled="isExporting">
                    <b-icon icon="download"></b-icon>
                    <span v-if="isExporting"><i class="fas fa-circle-notch fa-spin"></i>{{ exportingLabel }}...</span>
                    <span v-else>{{ hasSelected ? exportLabel : exportAllResultLabel }}</span>
                </button>   
            </template>


            <b-dropdown-item aria-role="listitem" class="has-text-left" v-on:click="exportDetails"><b-icon icon="download"></b-icon>{{ downloadLabel }}</b-dropdown-item>
            <b-dropdown-item aria-role="listitem"  v-on:click="showEmailModal"><b-icon icon="at"></b-icon>{{ sendViaEmailLabel }}</b-dropdown-item>
       
        </b-dropdown>
        <b-modal  has-modal-card class="has-custom-container" v-model="showEmailInput" #default="props"  aria-role="dialog" close-button-aria-label="Close"
            aria-modal>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ sendViaEmailLabel }}</p>
                </header>
                <section class="modal-card-body">
                    <b-field :label="inputLabel" :type="errors.Recipients ? 'is-danger' : ''" :message="errors.Recipients">
                        <b-taginput v-model="recipients"
                            icon="label"
                            attached
                            :placeholder="inputPlaceholder"
                            aria-close-label="Delete this email address">
                        </b-taginput>
                    </b-field>
                </section>
                <footer class="modal-card-foot buttons is-right">
                    <button type="button" class="button is-primary" :disabled="isSending" @click.prevent="sendEmail">
                        <span v-if="isSending"><i class="fas fa-circle-notch fa-spin"></i> {{ sendingLabel }}...</span>
                        <span v-else>{{ sendLabel }}</span>
                    </button>
                    <b-button :label="cancelLabel" @click="props.close"></b-button>
                </footer>
            </div>
        </b-modal>
    </section>
	`
});